export class DialogModelErrorList {
    constructor(
        public errors: any
    ) {}
  }